import script from "./MailAttachement.vue?vue&type=script&setup=true&lang=ts"
export * from "./MailAttachement.vue?vue&type=script&setup=true&lang=ts"

import "./MailAttachement.vue?vue&type=style&index=0&id=26d21e14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d21e14"]])

export default __exports__